<!-- WonderYjjRate.vue -->
 <!-- 资金流入分析 -->
<template>
	<div>
		<div class="row mb-3">
			<div class="col-12">
				<b-form-datepicker
					id="datepicker"
					v-model="selectedEndDate"
					:min="minDate"
					:max="maxDate"
					locale="zh"
					today-button
					reset-button
					close-button
					placeholder="选择日期"
					@input="onDateChange"
					class="mb-2"
				></b-form-datepicker>
                <div class="d-flex align-items-center flex-wrap mt-1">
                    <span class="ml-2" style="font-size: 14px; color: #666;">显示最近 {{dayn}} 个交易日</span>
                    <b-form-select v-model.number="dayn" :options="daynOptions" size="sm" class="ml-2 w-auto" @change="onDaynChange"></b-form-select>
                    <b-form-checkbox v-model="showMoney" switch class="ml-3">显示资金</b-form-checkbox>
                    <b-form-checkbox v-model="showKP" switch class="ml-3">KP</b-form-checkbox>
                    <b-form-radio-group
                        v-model="selectedCycle"
                        :options="cycleOptions"
                        buttons
                        button-variant="outline-primary"
                        size="sm"
                        class="ml-3"
                    ></b-form-radio-group>
                    <span class="ml-2" style="font-size: 14px; color: #666;">周期</span>
                    <b-form-radio-group
                        v-model="selectedNType"
                        :options="nTypeOptions"
                        buttons
                        button-variant="outline-primary"
                        size="sm"
                        class="ml-3"
                    ></b-form-radio-group>
                    <span class="ml-2" style="font-size: 14px; color: #666;">排序</span>
                    <b-form-checkbox v-model="showUplimitStepFlag" switch class="ml-3">涨停梯队</b-form-checkbox>
                    <b-form-checkbox v-model="focusEnabled" switch class="ml-3">鬼画符</b-form-checkbox>
                    <b-form-checkbox v-model="showMinChart" switch class="ml-3">分时</b-form-checkbox>
                </div>

			</div>
				
		</div>
		<div class="row">
			<template v-if="days.length">
				<RateRangePlate v-for="day in days" :date1="day" :key="day + '-' + selectedEndDate" :plate_type=17
					:selectedPlateCode="selectedPlateCode" :selectedPlateName="selectedPlateName" 
					:is_show_row2="showMoney" :data_src="showKP ? 2 : 1" :n_days="selectedCycle" :n_type="selectedNType" :showUplimitStep="showUplimitStepFlag?1:0"
					:focusEnabled="focusEnabled" :showMinChart="showMinChart" :prevCodes="prevCodesByDay[day] || []"
					@plate-selected="handlePlateSelected"
					@show_sidebar="show_sidebar" @first-plate-loaded="handleFirstPlateLoaded" @show-plate-kline="handleShowPlateKline" @plates-loaded="handlePlatesLoaded">
				</RateRangePlate>
			</template>
		</div>
		<div class="row">
			<div class="col col-xl-3 col-lg-3 col-md-4 col-sm-6" v-if="selectedPlateCode">
				<!-- <PlateStockPopular :plate_type=17 :plate_code="selectedPlateCode" :p_date=selectedDate @p_show_kline="handleShowKline" @date-selected="handleDateSelected"></PlateStockPopular> -->
				<PlateStockPopularTable  :plate_type=17 :plate_code="selectedPlateCode" :p_date=selectedDate @p_show_kline="handleShowKline" @date-selected="handleDateSelected" />
			</div>
			<div class="col col-xl-9 col-lg-9 col-md-8 col-sm-6">
				<StockKlineDay v-if="selectedPlateCode" :symbol_code="selectedPlateCode" :title="selectedPlateName" :subText="selectedPlateCode" :highlightDate="selectedDate" :chart_heigh="'400px'" :zoom_start=40></StockKlineDay>

				<StockMultiChart v-if="symbol_code" :symbol_code="symbol_code" :symbol_name="symbol_name" :selectedDate="selectedDate"
					:chart_width="'900px'">
				</StockMultiChart>

			</div>
		</div>

        <!-- 板块K线图（组件化） -->
        <PlateKlineModal
            :visible="showPlateKline"
            :plateCode="selectedPlateCode"
            :plateName="selectedPlateName"
            :selectedDate="selectedDate"
            @close="closePlateKline"
        />

		<StockInfoSidebar :symbol_code="symbol_code" :symbol_name="symbol_name" :date_mark="date_mark"></StockInfoSidebar>

	</div>
	
</template>

<script>
    import YjjMixin from '../../mixins/views/wonder/YjjMixin.js'
    import moment from 'moment'
    import { request_zzquant } from "network/request.js"
    import PlateKlineModal from 'components/plate/PlateKlineModal.vue'


    export default {
        mixins: [YjjMixin],
        data() {
			return {
				minDate: moment().subtract(3, 'year').format('YYYY-MM-DD'),
				maxDate: moment().format('YYYY-MM-DD'),
				// 如果当前时间是在09:31之前或者是凌晨时间段，则结束日期不加一天
				selectedEndDate: (() => {
					const now = moment();
					const currentTime = now.format('HH:mm');					
					if (currentTime < '09:31'){
						return now.format('YYYY-MM-DD');
					} else {
						return now.add(1, 'days').format('YYYY-MM-DD');
					}
				})(),
				showMoney: false, // 控制是否显示资金的开关
			showKP: false, // 控制是否使用KP数据源
			showPlateKline: false,
			firstPlateSet: false,
			selectedCycle: 5, // 默认选择5日周期
			cycleOptions: [
				{ text: '1日', value: 1 },
				{ text: '3日', value: 3 },
				{ text: '5日', value: 5 }
			],
			selectedNType: 3, // 默认“资金”
			nTypeOptions: [
				{ text: '资金', value: 3 },
				{ text: '强度', value: 9 },
				{ text: '涨幅', value: 1 }
			],
				showUplimitStepFlag: false, // 控制是否显示涨停梯队的开关
				showMinChart: false,
				focusEnabled: false,
					prevCodesByDay: {},
					loadedCodesByDay: {},
					allDays: [],
					daynOptions: [6,8,10,12,15],
				}
        },
        mounted() {
			// 设置默认日期为当天
			if (!this.selectedDate) {
				// 如果当前时间是在09:31之前或者是凌晨时间段（00:00-04:00），则取前一天的日期
				const now = moment();
				this.selectedDate = now.format('YYYY-MM-DD');
			}
		},
		watch: {
			// 监听KP开关状态变化，触发数据刷新
			showKP(){ this.get_trade_days(); },
			focusEnabled(){ this.updatePrevCodesByDay(); },
			selectedCycle(){ this.updatePrevCodesByDay(); },
            selectedNType(){ this.updatePrevCodesByDay(); },
            dayn(){ this.get_trade_days(); }
        },
        components: {
            PlateKlineModal
        },
        methods: {
			// 日期选择变化处理
			onDateChange() {
				// 重置选中状态
				this.selectedPlateCode = null;
				
				// 触发数据刷新
				this.get_trade_days();
			},
			// 首次板块加载时设置默认选中，避免未选中导致内容为空
			handleFirstPlateLoaded(plateCode, date) {
				if (!this.firstPlateSet && this.days && this.days.length > 0 && date === this.days[0]) {
					this.selectedPlateCode = plateCode;
					this.firstPlateSet = true;
				}
			},
			handleShowKline(stock_code, stock_name) {
				this.symbol_code = stock_code
				this.symbol_name = stock_name
			},
			handleDateSelected(date) {
				this.selectedDate = date
			},
			show_sidebar(stock_info) {
				this.symbol_code = stock_info['stock_code'];
				this.symbol_name = stock_info['stock_name'];
				this.date_mark = stock_info['date1'];
			},
			// 重写get_trade_days方法，使用selectedEndDate
			get_trade_days() {
				const today = this.selectedEndDate;
				request_zzquant({
						url: '/market/trade/days?day_end=' + today + '&days=' + (this.dayn + 3)
					})
					.then(res1 => {
						const raw = res1['data']['data'] || [];
						this.allDays = raw.slice().sort((a,b)=> new Date(b) - new Date(a));
						this.days = this.allDays.slice(0, this.dayn);
						this.selectedDate = this.days[0]
						this.prefetchPrevDaysForHighlights().then(()=>{ this.updatePrevCodesByDay(); });
					})
					.catch(err => {
						console.log(err);
					});
			},
			// 处理板块K线图显示
			handleShowPlateKline(plateInfo) {
				this.selectedPlateCode = plateInfo.code;
				this.selectedPlateName = plateInfo.name;
				this.showPlateKline = true;
			},
			
			// 关闭板块K线图
            closePlateKline() {
                this.showPlateKline = false;
            },
            onDaynChange(){ this.get_trade_days(); },
            handlePlatesLoaded(payload){
                if(payload && payload.day){
                    this.$set(this.loadedCodesByDay, payload.day, Array.isArray(payload.codes) ? payload.codes : []);
                    this.updatePrevCodesByDay();
                }
            },
			async updatePrevCodesByDay(){
				if(!this.focusEnabled || !this.days || this.days.length===0){ this.prevCodesByDay={}; return; }
				const map = {};
				for(let i=0;i<this.days.length;i++){
					const day=this.days[i];
					const prevDays=[];
					const idx = this.allDays.indexOf(day);
					for(let j=1;j<=3;j++){ const k=idx+j; if(k<this.allDays.length){ prevDays.push(this.allDays[k]); } }
					let codes=new Set();
					prevDays.forEach(d=>{ const arr=this.loadedCodesByDay[d]; if(arr && arr.length){ arr.forEach(c=> codes.add(c)); } });
					map[day]=Array.from(codes);
				}
				this.prevCodesByDay=map;
			}
			,
			async prefetchPrevDaysForHighlights(){
				const plateType=17;
				const dataSrc=this.showKP ? 2 : 1;
				const nDays=this.selectedCycle;
				const extraDays = this.allDays.slice(this.dayn, this.dayn+3);
				const reqs = extraDays.map(d=> request_zzquant({url:`/market/plates/${plateType}/rank/days?date2=${d}&n_days=${nDays}&data_src=${dataSrc}&n_type=${this.selectedNType}`})
					.then(r=>{ const arr=r.data && r.data.data ? r.data.data : []; this.$set(this.loadedCodesByDay, d, arr.map(it=> it.plate_code).filter(Boolean)); })
					.catch(()=>{ this.$set(this.loadedCodesByDay, d, []); })
				);
				return Promise.all(reqs);
			}
		}
	}
</script>

<style>
.b-form-datepicker {
    max-width: 300px;
}
</style>
